//import { computed } from 'vue';
import { useRouter } from 'vue-router';
import StringUtils from '@/utils/StringUtils';
import ConstUtils from '@/utils/ConstUtils';

export function useProfile(domainRef = null) {
  const router = useRouter();

  const toggleV2 = (company) => {
    toggleUi(false, company);
  };

  const toggleV3 = (company) => {
    toggleUi(true, company);
  };

  const toggleUi = (value, company) => {
    localStorage.setItem('v3', value);
    if (!value) {
      localStorage.removeItem('rc-theme');
    }
    let isAdmin = false;
    if (domainRef.session().employee().find().roles().find().isAdministrator()) {
      isAdmin = true;
    }
    let homePath = ConstUtils.ROUTES.HOME_PATH;
    if (company != null || company != undefined) {
      homePath = StringUtils.format(ConstUtils.ROUTES.HOME_PATH, [company.idEncoded()]);
    }
    if (isAdmin) {
      homePath = ConstUtils.ROUTES.V2.COMPANY_PATH;
    }
    router.push({ path: homePath })
      .then(() => {
        window.location.reload();
      })
      .catch(err => {
        console.error("Navigation error during V3 toggle:", err);
        window.location.reload();
      });
  };

  return {
    toggleV2,
    toggleV3,
  };
}